<template>
  <section class="invoice-add-wrapper">
    <validation-observer
      ref="formRetention"
      v-slot="{ invalid }"
    >
      <b-form>
        <b-card>
          <b-row>
            <!--  BOTON -->
            <b-col md="2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-dark"
                class="mb-50"
                block
                @click.prevent="nuevo()"
              >
                <feather-icon
                  icon="FileIcon"
                  class="mr-50"
                />
                Nuevo
              </b-button>
            </b-col>

            <!-- id movimiento -->
            <b-col md="12">
              <b-form-group
                hidden
                label-for="idmonedacotizacion"
                label="Codigo Cotizacion"
                class="text-danger"
              >
                <b-form-input
                  id="idmonedacotizacion"
                  v-model="idmonedacotizacion"
                  placeholder="Codigo Cotizacion"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- moneda -->
            <b-col md="3">
              <b-form-group
                label="* Moneda"
                label-for="moneda"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Moneda"
                  rules="required"
                >
                  <v-select
                    v-model="moneda"
                    :dir="
                      $store.state.appConfig.isRTL
                        ? 'rtl'
                        : 'ltr'
                    "
                    label="moneda"
                    :options="monedalista"
                    :clearable="false"
                    input-id="idmoneda"
                  />
                  <small class="text-danger">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- fecha -->
            <b-col md="3">
              <b-form-group
                label-for="fecha"
                label="* Fecha Cotizacion"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="Fecha"
                  rules="required"
                >
                  <flat-pickr
                    id="fecha"
                    v-model="fecha"
                    class="form-control"
                    :config="{
                      dateFormat: 'Y-m-d',
                    }"
                    :state="
                      errors.length > 0 ? false : null
                    "
                  />
                  <small class="text-danger">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!--  venta -->
            <b-col md="3">
              <b-form-group
                label="* Venta"
                label-for="venta"
              >
                <cleave
                  id="venta"
                  v-model="venta"
                  placeholder="Venta"
                  class="form-control"
                  :raw="false"
                  :options="options.number"
                  style="text-align: right"
                />
              </b-form-group>
            </b-col>

            <!--  compra -->
            <b-col md="3">
              <b-form-group
                label="* Compra"
                label-for="compra"
              >
                <cleave
                  id="compra"
                  v-model="compra"
                  placeholder="Compra"
                  class="form-control"
                  :raw="false"
                  :options="options.number"
                  style="text-align: right"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <b-row>
            <!-- BOTONES DE GUARDAR  -->
            <b-col md="6" />
            <b-col md="3" />
            <b-col md="3">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-50"
                block
                type="submit"
                :disabled="invalid"
                @click.prevent="save"
              >
                <feather-icon
                  icon="SaveIcon"
                  class="mr-50"
                />
                Guardar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-form>
    </validation-observer>
  </section>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import { heightTransition } from "@core/mixins/ui/transition"
import { required } from "@validations"
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BCollapse,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BFormValidFeedback,
  BInputGroup,
  BOverlay,
  BRow,
  BSpinner,
  BTable,
  VBToggle,
} from "bootstrap-vue"
import "leaflet/dist/leaflet.css"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import VueAutosuggest from "vue-autosuggest"
import Cleave from "vue-cleave-component"
import flatPickr from "vue-flatpickr-component"
import "vue-form-wizard/dist/vue-form-wizard.min.css"
import Ripple from "vue-ripple-directive"
import vSelect from "vue-select"

export default {
  components: {
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BTable,
    VBToggle,
    BCollapse,
    BFormSelect,
    BCard,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    vSelect,
    Cleave,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BInputGroup,
    BSpinner,
    BCardBody,
    flatPickr,
    VueAutosuggest,
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      idmonedacotizacion: 0,
      moneda: [],
      monedalista: [],
      fecha: null,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          numeralDecimalScale: 3,
        },
      },
      venta: 0,
      compra: 0,
      required,
    }
  }, // fin methods

  computed: {},

  created() {
    window.addEventListener("resize", this.initTrHeight)
    // fecha
    const date = new Date()
    this.fecha =
            `${date.getFullYear() 
            }-${ 
              date.getMonth() + 1 
            }-${ 
              date.getDate()}`
    this.loadData()
  },

  methods: {
    loadData() {
      this.getMoneda()
    },

    save() {
      this.$refs.formRetention.validate().then((success) => {
        if (success) {
          this.$swal({
            title: "Seguro, Quieres Guardar?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Guardar",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.$http
                .post("/moneda", {
                  idempresa: this.userData.idempresa,
                  idusuario: this.userData.id,
                  idmoneda: this.moneda.idmoneda,
                  fecha: this.fecha,
                  venta: this.venta.replace(
                    new RegExp(",", "g"),
                    "",
                  ),
                  compra: this.compra.replace(
                    new RegExp(",", "g"),
                    "",
                  ),
                })
                .then((response) => {
                  // alert(response.data.msn);
                  const {msn} = response.data
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Guardado con Exito....",
                      icon: "EditIcon",
                      variant: "success",
                    },
                  })
                  this.nuevo()
                })
                .catch((error) => {
                  this.working = false
                  const err = error.response.data.error
                    ? error.response.data.error
                    : error.message
                  console.log(error)
                  this.$swal({
                    title: "Error",
                    text: "No se realizo la Transaccion, vuelva a Intentar o Consulte con el Administrador...",
                    icon: "error",
                  })
                })
            }
          })
        }
      })
    }, // fin method save
    nuevo() {
      this.$router.go(0)
    },
    toUpperCase(value) {
      return value.toUpperCase()
    },
    rowClass() {},
    getMoneda() {
      // MONEDA
      this.$http
        .get("/moneda", {
          params: {
            idempresa: this.userData.idempresa,
          },
        })
        .then((response) => {
          this.monedalista = response.data.data
          this.venta = response.data.data1
          this.compra = response.data.data2
          this.setMonedaDefault(this.monedalista)
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    setMonedaDefault(obj) {
      for (const x of obj) {
        if (x.principal == false) this.moneda = x
      }
    },

    formatMoneda(value) {
      const val = (value / 1).toFixed(2).replace(",", ".")
      
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
